import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import './styles.css';
SwiperPage4.propTypes = {
  id: PropTypes.string,
  isActive: PropTypes.bool,
};

SwiperPage4.defaultProps = {
  id: '',
  isActive: false,
};

function SwiperPage4({ id, isActive }) {
  const [animationClass, setAnimationClass] = useState('');
  const slides = [{ id: 1 }, { id: 2 }, { id: 3 }];
  useEffect(() => {
    if (isActive) {
      setAnimationClass('active'); // Khi active, chạy animation
    } else {
      setAnimationClass(''); // Nếu không active, reset
    }
  }, [isActive]);

  return (
    <div className={`hero-section hero-section-${id} ${animationClass}`}>
      <div class="hero-content">
        {/* <!-- Information Box --> */}
        <div class="information-accessories-box">
          <h1 class="title">Phụ Kiện Boardgame</h1>
          <p class="description">
            <span>
              Phụ kiện nhựa giúp trải nghiệm boardgame đẹp, tiện lợi và bền hơn. Các loại phổ biến như token, tháp xí
              ngầu,... và khay đựng giúp sắp xếp gọn gàng và tăng sự thú vị khi chơi. Đây là lựa chọn tuyệt vời để nâng
              cấp bộ sưu tập boardgame của bạn.
            </span>
          </p>
          <div className="cta-button">
            <a
              href="https://www.facebook.com/GamePieceLabs"
              className="cta-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Tư vấn phụ kiện
            </a>
          </div>
        </div>
        {/* <!-- Information Box --> */}
        <div className="w-[600px] aspect-[16/9] mx-auto album-accessories-box">
          <Swiper modules={[Pagination]} pagination={{ clickable: true }} spaceBetween={10} slidesPerView={1}>
            {slides.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div className={`w-full h-full bg-cover bg-center accessories-box-${slide.id}`} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default SwiperPage4;
